import { FormControl, MenuItem, Select, InputLabel } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function FieldTypeByte({variableActionNode,submitChange}) {
  const { t } = useTranslation();
  const [bitPosition, setBitPosition] = useState("1");
  const [bitValue, setBitValue] = useState("0");
  const bitOptions = {
    bitPosition: ['1','2','3','4','5','6','7','8'],
    bitValue: ["0","1"]
  };

  const handleBitPositionChange = (e) => {
    setBitPosition(e.target.value);
    submitChange(null,null,{BIT_POSITION:e.target.value})
  };

  const handleBitValueChange = (e) => {
    setBitValue(e.target.value);
    submitChange(null,null,{VALUE:e.target.value})
  };
  useEffect(()=>{
    setBitPosition(variableActionNode.BIT_POSITION || '1')
    setBitValue(variableActionNode.VALUE || '0')
  },[variableActionNode])
  
  return (
    <>
      <FormControl variant="outlined" className="width-100" size="small">
        <InputLabel id="bitPositionLabel">{t("LBL_BIT_POSITION")}</InputLabel>
        <Select
          className="width-100"
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 300,
              },
            },
          }}
          name="BP"
          value={bitPosition}
          labelId="bitPositionLabel"
          label={t("LBL_BIT_POSITION")}
          onChange={handleBitPositionChange}
        >
          {bitOptions.bitPosition.map((val, index) => (
            <MenuItem key={index} value={val}>
              {val}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" className="width-100" size="small">
        <InputLabel id="bitValueLabel">{t("LBL_BIT_VALUE")}</InputLabel>
        <Select
          className="width-100"
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 300,
              },
            },
          }}
          name="BV"
          value={bitValue}
          labelId="bitValueLabel"
          label={t("LBL_BIT_VALUE")}
          onChange={handleBitValueChange}
        >
          {bitOptions.bitValue.map((val, index) => (
            <MenuItem key={index} value={val}>
              {val}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
}

export default FieldTypeByte;
